import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation, Link } from 'react-router-dom';
import { Form, Button, Row, Col } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import {
  getInterestApplication,
  reviewInterestApplication,
} from 'store/fundingAdmin/actions';
import { FormField, UploadWithoutCreds } from 'components';
import { formFields1, formFields2 } from './formFields';
import { omit, isEmpty } from 'lodash';
import { registerDocs } from './registerDocs';
import { SuccessModal, InvalidModal } from 'components/layout/components';
import { ReactComponent as ArrowLeft } from '../../../assets/icons/arrow-left.svg';
import SubmitModal from './components/submitModal';
import RejectModal from './components/rejectModal';

const RegisterPageConfirmation = () => {
  const [form] = useForm();
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setVisible] = useState(false);
  const [isVisibleSubmit, setVisibleSubmit] = useState(false);
  const [isVisibleReject, setVisibleReject] = useState(false);
  const [isVisibleError, setVisibleError] = useState(false);
  const [comment, setComment] = useState('');
  const error = useSelector(state => state.fundingAdmin?.error);
  const register = useSelector(
    state => state.fundingAdmin?.interestApplication
  );
  const documents = useSelector(
    state => state.fundingAdmin?.interestApplication?.documents
  );
  const viewMode = location.pathname.includes('view');

  useEffect(() => {
    if (!isEmpty(error)) setVisibleError(true);
  }, [error]);

  useEffect(() => {
    if (!isVisibleReject) setComment('');
  }, [isVisibleReject]);

  useEffect(() => {
    if (params?.id) {
      dispatch(getInterestApplication(params?.id));
    }
  }, [params?.id]);

  useEffect(() => {
    if (register) {
      form.setFieldsValue({
        ...register,
      });
    }
  }, [register, form]);

  const handleSubmit = accept => {
    const payload = {
      id: params?.id,
      accept: accept,
      comment: comment,
    };
    dispatch(
      reviewInterestApplication(payload, check => {
        setVisible(!check);
      })
    );
  };

  return (
    <>
      <SubmitModal
        isVisible={isVisibleSubmit}
        setVisibleSubmit={setVisibleSubmit}
        setIsVisible={setVisibleSubmit}
        handleSubmit={handleSubmit}
      />
      <RejectModal
        isVisible={isVisibleReject}
        setIsVisible={setVisibleReject}
        setVisibleReject={setVisibleReject}
        handleSubmit={handleSubmit}
        comment={comment}
        setComment={setComment}
      />
      <SuccessModal
        isVisible={isVisible}
        setVisible={setVisible}
        title={'Επιτυχής Υποβολή!'}
        message={'Η αξιολόγηση καταχωρήθηκε επιτυχώς.'}
        returnButtonTitle={'Επιστροφή στην Αρχική'}
        returnButtonNavigate={'/loginAs'}
      />
      <InvalidModal
        isVisible={isVisibleError}
        setVisible={setVisibleError}
        error={error}
        returnButtonTitle={'Επιστροφή στην Αρχική'}
        returnButtonNavigate={'/fundingadminpage'}
      />
      <div className="main-wrapper register-page-wrapper">
        <div className="register-page-card">
          <div
            id="register-page-card-title"
            className="register-page-card-title"
          >
            Δήλωση Ενδιαφέροντος
          </div>
          <div className="mt-2">
            <Form
              form={form}
              trigger="onChange"
              className="register-page"
              initialValues={{ ...register }}
            >
              <div
                className="carrier-data-form register"
                style={{ width: '47%', display: 'inline-block' }}
              >
                <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  // className="carrier-data-form__row"
                >
                  {formFields1.map((field, index) => {
                    return (
                      <Col
                        key={index}
                        className={`gutter-row ${
                          field.name === 'firstName' ||
                          field.name === 'lastName' ||
                          field.name === 'foundingDate' ||
                          field.name === 'phoneNumber'
                            ? 'specific-col'
                            : ''
                        }`}
                        span={field.span}
                      >
                        <Form.Item
                          name={[field.name]}
                          rules={field.rules}
                          validateFirst
                        >
                          <FormField
                            key={index}
                            disabled={field?.disabled}
                            {...omit(field, [
                              'span',
                              'rules',
                              'offset',
                              'disabled',
                            ])}
                          />
                        </Form.Item>
                      </Col>
                    );
                  })}
                </Row>
              </div>
              <div
                className="carrier-data-form"
                style={{
                  width: '47%',
                  display: 'inline-block',
                  marginLeft: '4%',
                }}
              >
                <Row
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  // className="carrier-data-form__row"
                  className="register-subject-form"
                >
                  {formFields2.map((field, index) => {
                    return (
                      <Col key={index} className="gutter-row" span={field.span}>
                        <Form.Item
                          name={[field.name]}
                          rules={field.rules}
                          validateFirst
                        >
                          <FormField
                            key={index}
                            disabled={field?.disabled}
                            {...omit(field, [
                              'span',
                              'rules',
                              'offset',
                              'disabled',
                            ])}
                          />
                        </Form.Item>
                      </Col>
                    );
                  })}
                </Row>
              </div>
              <div className={'register-docs-container mt-2'}>
                {documents &&
                  registerDocs().map((item, index) => (
                    <UploadWithoutCreds
                      item={item}
                      subFileCode={item.fileCode}
                      path={'fundingAdmin.interestApplication'}
                      key={index}
                      group={'documents'}
                      view={true}
                    />
                  ))}
              </div>
              {!viewMode && (
                <div className="register-buttons mt-2">
                  <Button
                    className="return-button mt-3"
                    type="secondary"
                    disabled={false}
                    onClick={() => setVisibleReject(true)}
                  >
                    Απόρριψη
                  </Button>
                  <Button
                    type="primary"
                    className="submit-login mt-3"
                    disabled={false}
                    onClick={() => setVisibleSubmit(true)}
                    id="inputEnter"
                  >
                    Έγκριση
                  </Button>
                </div>
              )}

              <div id="go-back" className="go-back mt-3">
                <Link to={'/fundingadminpage'}>
                  <ArrowLeft />
                  <span>Πίσω στις Δηλώσεις</span>
                </Link>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisterPageConfirmation;
